import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { RESTAURANT } from "@/data/menu";
import { FOOTER } from "@/constants/testIds";

const logo = "/images/logo.png";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-brand text-cream/85 mt-24"
    >
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src={logo}
            alt="Giridhar"
            className="h-12 w-auto object-contain"
          />
          <p className="mt-6 max-w-md text-cream/70 leading-relaxed">
            A family-run kitchen in Aundh, Pune, founded by Shri Bhivlal Bishnoi
            in 1991. Three decades on, we still serve the same recipes —
            slow-cooked, generously spiced, and always vegetarian.
          </p>
          <div className="mt-6 flex flex-wrap gap-4 text-[0.7rem] text-cream/55 uppercase tracking-[0.16em]">
            <span>
              <span className="block text-cream/40 mb-1">FSSAI</span>
              {RESTAURANT.fssai}
            </span>
            <span>
              <span className="block text-cream/40 mb-1">GSTIN</span>
              {RESTAURANT.gstin}
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-serif text-lg text-cream mb-4">Visit</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-cream/60 shrink-0" />
              <span>{RESTAURANT.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-cream/60 shrink-0" />
              <a href={`tel:${RESTAURANT.phoneRaw}`} className="hover:text-cream transition">
                {RESTAURANT.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-cream/60 shrink-0" />
              <a href={`mailto:${RESTAURANT.email}`} className="hover:text-cream transition">
                {RESTAURANT.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg text-cream mb-4">Hours</h4>
          <ul className="space-y-2 text-sm">
            {RESTAURANT.hours.map((h) => (
              <li key={h.day} className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-0.5 text-cream/60 shrink-0" />
                <span>
                  <span className="block text-cream/90">{h.day}</span>
                  <span className="block text-cream/60">{h.time}</span>
                </span>
              </li>
            ))}
          </ul>
          <div className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-sm">
            <Link to="/" data-testid={FOOTER.homeLink} className="text-cream/70 hover:text-cream transition">Home</Link>
            <Link to="/menu" data-testid={FOOTER.menuLink} className="text-cream/70 hover:text-cream transition">Menu</Link>
            <Link to="/about" data-testid={FOOTER.aboutLink} className="text-cream/70 hover:text-cream transition">About</Link>
            <Link to="/contact-us" data-testid={FOOTER.contactLink} className="text-cream/70 hover:text-cream transition">Contact</Link>
            <Link to="/terms" data-testid={FOOTER.termsLink} className="text-cream/70 hover:text-cream transition">Terms</Link>
          </div>
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="container-x py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/55">
          <p>© {new Date().getFullYear()} Giridhar Veg Restaurant. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/terms" className="hover:text-cream transition">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}